import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import FooterFooter from "../../components/footerfooter";
//IMPORT DYNAMIC STYLED COMPONENT
import { StyledHeader } from "../../Styles";
import "./dashboard.css";

import { CONFIG } from "../../../config.js";
import { ABI, DashboardFunctions } from "./functions";
import { useMoralis, useWeb3ExecuteFunction } from "react-moralis";

//SWITCH VARIABLE FOR PAGE STYLE
const theme = "GREY"; //LIGHT, GREY, RETRO

const Settokenuri = () => {
  const [tokenUri, setTokenUri] = useState({});

  const {
    authenticate,
    isAuthenticated,
    user,
    Moralis,
    setUserData,
    userError,
    isWeb3Enabled,
    account,
    ...xyz
  } = useMoralis();

  const handleTokenURL = (event) => {
    const { name, value } = event.target;
    setTokenUri({
      ...tokenUri,
      [name]: value,
    });
  };
  const SetTokenURI = async (tokenURI, tokenId) => {
    console.log(tokenUri);
    console.log(tokenURI);
    console.log(tokenId);
    await Moralis.enableWeb3();

    let options = {
      chain: CONFIG.chainID,
      contractAddress: CONFIG.smart_contract_unstaked,
      functionName: "setTokenURI",
      abi: ABI.setTokenURI,
      params: {
        MooseURI: tokenURI,
        tokenID: tokenId,
      },
    };
    try {
      const setTokenURITransaction = await Moralis.executeFunction(options);
      console.log(
        "setTokenURITransaction=>",
        setTokenURITransaction,
        "setTokenURITransactionhash",
        setTokenURITransaction.hash
      );
      alert("Please wait for confirmation");
      await setTokenURITransaction.wait();
      alert("Transaction Confirmed");
    } catch (e) {
      console.log("setTokenURITransaction=>", e);
      alert("Oops some problem occured! Please try again later!");
    }
  };

  return (
    <>
      <div className="greyscheme">
        <StyledHeader theme={theme} />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="dark"
          pauseOnHover
        />
        <div className="greyscheme">
          <section className="container">
            <div className="settokenuri_form" style={{ padding: "40px 0" }}>
              <h4 className="text-center py-5">Set Token And URL</h4>
              <div className="form_wrapper">
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="tokenURI"
                      placeholder="Enter token URI"
                      onChange={handleTokenURL}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="tokenId"
                      placeholder="Enter token ID"
                      onChange={handleTokenURL}
                      className="form-control"
                    />
                  </div>
                </div>
                <button
                  id="walletButton"
                  className="btn-main m-auto my-3"
                  type="button"
                  onClick={() =>
                    SetTokenURI(tokenUri.tokenURI, tokenUri.tokenId)
                  }
                >
                  Submit
                </button>
              </div>
            </div>
          </section>
          <br />
          <br />
          <FooterFooter />
        </div>
      </div>
    </>
  );
};
export default Settokenuri;
